import { render, staticRenderFns } from "./channelClass.vue?vue&type=template&id=0b9e786c&scoped=true&"
import script from "./channelClass.vue?vue&type=script&lang=js&"
export * from "./channelClass.vue?vue&type=script&lang=js&"
import style0 from "./channelClass.vue?vue&type=style&index=0&id=0b9e786c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e786c",
  null
  
)

export default component.exports